export default [{
        title: '作为护理考生，你不得不关注这个！',
        name: 'nurse/181225',
    },
    {
        title: '免费送 | 2019版一级消防考试《通关宝典》图书+课程',
        name: 'fire/181227',
    },
    {
        title: '密训营',
        name: 'yatiku/190107'
    },
    {
        title: '免费领！2019初级会计职称考试用书送不停！',
        name: 'accounting/190108'
    },
    {
        title: '2019执业药师新大纲改动内容对比表',
        name: 'yatiku/siteIndex'
    },
    {
        title: '2019执业药师新大纲改动内容对比表',
        name: 'yatiku/site'
    },
    {
        title: '2019教师密训押题班',
        name: 'yatiku/190122'
    },
    {
        title: '优学官方旗舰店',
        name: 'yatiku/190123'
    },
    {
        title: '新春大礼包',
        name: 'yatiku/newyear'
    },
    {
        title: '考生大实话',
        name: 'yatiku/190226'
    },
    {
        title: '考生大实话',
        name: 'yatiku/191127'
    },
    {
        title: '考生大实话',
        name: 'fire/190227'
    },
    {
        title: '押题神话',
        name: 'fire/190226'
    },
    {
        title: '押题神话',
        name: 'fire/1902261'
    },
    {
        title: '鸭题库',
        name: 'yatiku/190306'
    },
    {
        title: '【官方最全】免费领取2019上半年教师资格真题及答案解析',
        name: 'teacher/190315'
    },
    {
        title: '『考前爆料』2019年雪狐狸密训押题班',
        name: 'nurse/190318'
    }
]


// WEBPACK FOOTER //
// ./src/route/basicPage.js